//
//
//
//
//
//

import index from './index';
export default {
  name: 'companyClient',
  components: {
    index: index
  }
};